import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router, UrlSegment } from '@angular/router';
import { TranslocoService } from '@ngneat/transloco';
import moment from 'moment';
import { BaseList } from 'projects/admin/src/app/classes/base-list';
import { ApiService } from 'projects/admin/src/app/services/api.service';
import { AuthStateService } from 'projects/admin/src/app/services/auth-state.service';
import { HelperService } from 'projects/admin/src/app/services/helper.service';
import { OrderHelperService } from 'projects/admin/src/app/services/order-helper.service';
import { UiService } from 'projects/admin/src/app/services/ui.service';
import { AcModel } from 'projects/core/src/lib/models/ac.model';

@Component({
  selector: 'app-order-list',
  templateUrl: './order-list.component.html',
  styleUrls: ['./order-list.component.scss']
})
export class OrderListComponent extends BaseList implements OnInit {

  public mode = 'orders';
  public orders: Array<AcModel> = [];
  public title: string = null;
  public dst: boolean = moment().isDST();
  public showDetails = false;
  public showFinished = false;

  protected apiUrl = '/planning/orders';

  constructor(
    protected router: Router,
    protected ui: UiService,
    protected helper: HelperService,
    protected api: ApiService,
    protected transloco: TranslocoService,
    protected auth: AuthStateService,
    private orderHelper: OrderHelperService,
    private route: ActivatedRoute,
  ) {
    super(router, ui, helper, transloco, auth);
  }

  ngOnInit(): void {
    const urlSegments: Array<UrlSegment> = this.route.snapshot.url;
    const urlType: UrlSegment = urlSegments[urlSegments.length - 1];
    this.mode = urlType.path;
    this.showDetails = JSON.parse(localStorage.getItem('list-details-' + this.mode)) || false;
    this.showFinished = JSON.parse(localStorage.getItem('order-list-show-finished')) || false;
    if (!['orders', 'clearings'].includes(this.mode)) {
      this.router.navigate(['/dashboard']);
    }
    this.apiUrl = '/planning/' + this.mode;
    this.title = this.transloco.translate('common.labels.' + this.mode);
    this.ui.setPageTitle(this.title);
    this.loadList();
  }

  public loadList(): void {
    this.loading = true;
    const params = (this.showFinished === true) ? { finished: true } : null;
    this.api.getModels(this.mode, params).subscribe({
      next: (result: any) => {
        this.orders = [];
        if (Array.isArray(result.data)) {
          this.orders = result.data.map((entry: any) => {
            const order = new AcModel().deserialize(entry);
            order.setTranslocoService(this.transloco);
            return order;
          });
        }
      },
      error: (error: any) => {

      }
    }).add(() => {
       this.loading = false;
    });
  }

  public saveListState(): void {
    localStorage.setItem('list-details-' + this.mode, JSON.stringify(this.showDetails));
  }

  public showFinishedChanged(): void {
    if (this.mode === 'orders') {
      localStorage.setItem('order-list-show-finished', JSON.stringify(this.showFinished));
      this.loadList();
    }
  }

  public onOpen(ac: AcModel): void {
    if (this.auth.hasRight('admin.planning-orders.show')) {
      this.router.navigate(['/planning/' + this.mode, ac.id]);
    }
  }

  public getDstLabel(): string {
    return ' (' + ((this.dst) ? 'MESZ' : 'MEZ') + ')';
  }

  public showNodatesInfo(event: any, order: AcModel): void {
    event.stopPropagation();
    this.orderHelper.showNodatesInfo(order);
  }


}
